import { Workspace } from '@/graphql/generated/types.generated';
import { stringAvatar } from '@/utils/string-avatar';
import { Avatar, AvatarProps } from '@mui/material';

type ProfileAvatarProps = Partial<Pick<Workspace, 'name' | 'color' | 'picture'>> & AvatarProps;
const ProfileAvatar = ({ name, color, picture, ...props }: ProfileAvatarProps) => {
    return (
        <Avatar
            src={picture || undefined}
            alt={name}
            variant="rounded"
            style={{
                backgroundColor: color,
                textTransform: 'uppercase',
                textAlign: 'center',
            }}
            {...props}
        >
            {stringAvatar(name)}
        </Avatar>
    );
};

export default ProfileAvatar;
